import React from "react";
import AnimatedNumber from "./AnimatedNumber";

/**
 * 4 stat squares with animated count-up numbers.
 */
const PalmGrid = ({ items }) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-[#d8cfbd] relative">
      {items.map((it, i) => (
        <div key={i} className="relative bg-[#f5f0e6] aspect-square overflow-hidden">
          <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4">
            <div className="font-serif-display text-5xl md:text-6xl text-[#1f2a24] tracking-tight">
              <AnimatedNumber
                value={it.value}
                decimals={it.decimals || 0}
                suffix={it.suffix || ""}
                duration={1600 + i * 180}
              />
            </div>
            <div className="mt-3 text-[10px] md:text-[11px] uppercase tracking-eyebrow text-[#3a4a40]">
              {it.label}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PalmGrid;
